import React, {useEffect, useState} from 'react';
import ResponsiveComponent from "../../../../../../components/Common/ResponsiveComponent";
import {useTranslation} from "react-i18next";
import {ReactComponent as ListIco} from "../../../../../../../images/icons/list.svg";
import {ReactComponent as MapIco} from "../../../../../../../images/icons/map.svg";
import {PlaceApi} from "../../../../../../services/Api/types";

interface Props {
    view: "list" | "map";
    setView: React.Dispatch<React.SetStateAction<"list" | "map">>;
    selectedPlace: PlaceApi | undefined;
}

const ToggleViewButton = ({view, setView, selectedPlace}: Props) => {
    const BOTTOM_OFFSET = 26;
    const {t} = useTranslation();
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [bottomOffset, setBottomOffset] = useState(BOTTOM_OFFSET);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setView("map");
            }
            setInnerWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [setView]);

    useEffect(() => {
        if (view === "list") {
            setBottomOffset(BOTTOM_OFFSET);
            return;
        }

        if (!selectedPlace || innerWidth > 768) return;

        const mapWrapperElement = document.querySelector(".map-wrapper");
        if (!mapWrapperElement) return;

        const card = mapWrapperElement.querySelector(".place-card") as HTMLElement;
        if (!card) return;

        const rect = card.getBoundingClientRect();
        setBottomOffset(rect.height + 16);
    }, [selectedPlace, innerWidth, view]);

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setView((prevState) => prevState === "map" ? "list" : "map");
        event.currentTarget.blur();
    };

    return (
        <ResponsiveComponent small={
            <button className="btn btn-default btn-icon btn-lg btn-primary view-button"
                    onClick={handleToggle} style={{bottom: `${bottomOffset}px`}}
                    aria-label={view === "list" ? t("modules.multistore.field.map_view.title") : t("modules.multistore.field.list_view.title")}
            >
                {view === "list" ? <MapIco aria-hidden="true"/> : <ListIco aria-hidden="true"/>}
            </button>
        } large={<></>} breakpoint={769}/>
    )
}

export default ToggleViewButton;